export class Api
{
  apiHost = process.env.VUE_APP_API_HOST;
  externalApiHost = process.env.VUE_APP_EXTERNAL_API_HOST;

  constructor() {

  }

  $http(config = {}) {
    if (window.qcsso == undefined) throw new Error('QCSSO SDK loaded failure.');

    if (config?.data && typeof config.data === 'object') config.data = JSON.stringify(config.data);
    if (config?.body && typeof config.body === 'object') config.body = JSON.stringify(config.body);

    return window.qcsso.request(config);
  }

  useData(res = {}, method = '') {
    if (res.data == undefined) throw new Error(method + ' API data not exist!');

    return res.data;
  }
}